import { tenantAwareApiWrapper, withOrchestratorClient } from './portal-http';
import { applicationsClient } from '@terra/shared-rest-clients-applications';
import type { ApplicationsContract } from '@terra/shared-contracts-applications';

export const portalCredentialsApi = {
  getCredentialsPreview: (applicationId: string) =>
    tenantAwareApiWrapper<typeof ApplicationsContract.getCredentialsPreview>({
      endpointFn: (headers) =>
        applicationsClient.getCredentialsPreview({
          params: { id: applicationId },
          ...withOrchestratorClient(headers),
        }),
    }),
};
